import semver from 'semver';
const isLocal = process.env.NODE_ENV === 'local';
export const isVersionGreaterThen = (currentVersion, versionToCompare) => {
    if (isLocal) {
        return true;
    }
    if (!currentVersion || !versionToCompare) {
        return false;
    }
    return semver.gt(currentVersion, versionToCompare);
};
